// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles__spinner___3g9Fd","gray":"styles__gray___1-_e4","light-gray":"styles__light-gray___bcQae","white":"styles__white___2RSo-","centered":"styles__centered___3OTMo"};